











































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster';

import LayersOutline from '~/components/icons/LayersOutline.vue';
import NavigationOutline from '~/components/icons/NavigationOutline.vue';
import XSolid from '~/components/icons/XSolid.vue';
import LocalisationDestinationCard from '~/components/cards/LocalisationDestinationCard.vue';
import EventCard from '~/components/cards/EventCard.vue';
import ProviderCard from '~/components/cards/ProviderCard.vue';
import RefreshOutline from '~/components/icons/RefreshOutline.vue';
import LocalisationRouteCard from '~/components/cards/LocalisationRouteCard.vue';
import ExtendedPopup from '~/components/partials/ExtendedPopup.vue';
import { ignScan25Url, ignStandardUrl } from "~/utils/map";

@Component({
  components: {
    LayersOutline,
    NavigationOutline,
    XSolid,
    'v-marker-cluster': Vue2LeafletMarkerCluster,
    LocalisationDestinationCard,
    EventCard,
    RefreshOutline,
    ProviderCard,
    LocalisationRouteCard,
    ExtendedPopup,
  },
  computed: {
    ...mapState('explorer', [
      'destinationRoutes',
      'destinationEvents',
      'destinationProviders',
      'hoveredRoutes',
    ]),
    ...mapState('lang', [
      'locale',
    ]),
  },
})
export default class DestinationMap extends Vue {
    @Prop(String) customHeight: '';
    @Prop(Boolean) isInLocalisationContext: false;
    @Prop(Array) destinations: Array<number>;
    @Prop(Array) routes: Array<Types.Route>;
    @Prop(Array) events: Array<Types.Event>;
    @Prop(Array) providers: Array<Types.Provider>;
    @Prop(Boolean) hideControls: false;
    @Prop(Object) hoveredEvent: {};
    @Prop(Object) hoveredRoute: Types.Route;
    @Prop(Object) hoveredProvider: {};
    @Prop(Array) destinationBounds: Array<number>;
    @Prop(String) activeTab: 'providers' | 'routes' | 'events';
    @Prop(Number) customZoom: 0;
    @Prop(Array) tracks: {difficulty: string, track: any, id: number}[];
    @Prop(Array) spots: number[];
    @Prop(String) destinationCountryCode: string;

    destinationRoutes: Types.RouteList;
    destinationEvents: Types.EventList;
    destinationProviders: Types.ProviderList;
    locale: string;
    hoveredRoutes: Types.Route[];

    $refs: {
      destinationMap: any,
      zoomContainer: any,
      routeCluster: any,
      eventCluster: any,
      providerCluster: any,
    }

    focusedMarker: any = null;

    clusterOptions = {
      animate: false,
      removeOutsideVisibleBounds: false,
      polygonOptions: {
        fillColor: '#1F2A44',
        color: '#1F2A44',
      },
    };

    routeItem: Types.Route | {} = {};
    eventItem: Types.Event | {} = {};
    providerItem: Types.Provider | {} = {};

    mapBounds: number[];

    focusedIcon = this.$L.icon({
      iconUrl: '/icons/PinFocus.svg',
      iconSize: [40, 40],
      iconAnchor: [16, 37],
      className: 'userIcon',
    })

    routesIcon = this.$L.icon({
      iconUrl: '/icons/PinDepartureCity.svg',
      iconSize: [40, 40],
      iconAnchor: [16, 37],
    })

    eventsIcon = this.$L.icon({
      iconUrl: '/icons/calendar.svg',
      iconSize: [40, 40],
      iconAnchor: [16, 37],
    })

    providersIcon = this.$L.icon({
      iconUrl: '/icons/PinProviders.svg',
      iconSize: [50, 50],
      iconAnchor: [16, 37],
      className: 'resetMarkerClass',
    })

    startingPointIcon = this.$L.icon({
      iconUrl: '/icons/PinSpot.svg',
      iconSize: [24, 24],
      className: 'resetMarkerClass removeBackground',
    })

    defaultHeight: string = '550px';
    actualZoom: number = 15;
    isXsDevice: boolean = false;
    panCustom: number[] = window.innerWidth >= 768 ? [300, 100] : [200, 100];

    isSettingsOpened: boolean = false;
    tileProviders: Types.TileProvider = [
      {
        id: 1,
        name: 'Streets',
        url: `https://api.maptiler.com/maps/streets/{z}/{x}/{y}.png?key=${this.$config.MAPTILER_KEY}`,
        attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      },
      {
        id: 2,
        name: 'Outdoor',
        url: `https://api.maptiler.com/maps/outdoor/{z}/{x}/{y}.png?key=${this.$config.MAPTILER_KEY}`,
        attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      },
      {
        id: 3,
        name: 'Satellite',
        url: `https://api.maptiler.com/tiles/satellite-v2/{z}/{x}/{y}.jpg?key=${this.$config.MAPTILER_KEY}`,
        attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      },
      {
        id: 4,
        name: 'IGN Standard',
        url: ignStandardUrl,
        attribution : "IGN-F/Géoportail",
      },
      {
        id: 5,
        name: 'IGN Scan 25',
        url: ignScan25Url,
        attribution : "IGN-F/Géoportail",
      },
    ]

    currentTile = this.tileProviders[0]
    picked = this.tileProviders[0].name
    spiderfiedCluster: any = null;

    isHovering: boolean = false;
    timer: any = null;

    hoveredMarkerId: number | null = null;
    arrayOfGeoJsons: any[] = [];
    spotMarkers: any = [];

    /*
      When an event is hovered in page and passed as prop, we will refresh clusters
      in map and spiderfy it if the associated event's marker is displayed in a
      cluster
    */
    @Watch('hoveredEvent')
    spiderfyEventMarkers (val: Types.Event) {
      this.$refs.eventCluster.mapObject.refreshClusters();
      setTimeout(() => {
        this.spiderfyCluster(val, this.$refs.eventCluster);
      }, 200);
    }

    /*
      When a provider is hovered in page and passed as prop, we will refresh clusters
      in map and spiderfy it if the associated provider's marker is displayed in a
      cluster
    */
    @Watch('hoveredProvider')
    spiderfyProviderMarkers (val: Types.Provider) {
      this.$refs.providerCluster.mapObject.refreshClusters();
      setTimeout(() => {
        this.spiderfyCluster(val, this.$refs.providerCluster);
      }, 200);
    }

    /*
      When the activeTab in the view changes, we force remove active marker,
      and associated opened popup
    */
    @Watch('activeTab')
    removeFocusedMarkerIfNeeded () {
      if (this.focusedMarker !== null) {
        if (this.$refs.destinationMap.mapObject.hasLayer(this.focusedMarker)) {
          this.$refs.destinationMap.mapObject.closePopup(this.focusedMarker);
          this.focusedMarker = null;
        }
      }
    }

    /*
      When a route is hovered in page and passed as prop, we will refresh clusters
      in map and spiderfy it if the associated route's marker is displayed in a
      cluster. This method has more logic as when a route is hovered, we also
      want to display associated track on the map.
    */
    @Watch('hoveredRoute')
    spiderfyRouteMarkers (val: Types.Route | { id: number } | null, preventBoolean: boolean) {
      this.$refs.routeCluster?.mapObject.refreshClusters();
      setTimeout(() => {
        this.spiderfyCluster(val, this.$refs.routeCluster);
      }, 200);

      clearTimeout(this.timer);

      if (val) {
        if (preventBoolean) this.hoveredMarkerId = val.id;

        this.isHovering = true;

        if (this.isHovering) {
          // Some timeout is added to ensure data is fecthed API-side if not
          // already available in the store.
          this.timer = setTimeout(this.drawHoveredRoute, 700);
        }
      } else {
        this.isHovering = false;
        this.hoveredMarkerId = null;
        for (const i in this.$refs.destinationMap.mapObject._layers) {
          if (this.$refs.destinationMap.mapObject._layers[i]._path !== undefined) {
            // Remove the track if no this.hoveredRoute is defined
            this.$refs.destinationMap.mapObject.removeLayer(this.$refs.destinationMap.mapObject._layers[i]);
          }
        }
      }
    }

    /* When the bounds are calculated, we want the map to be fit on its bounds */
    @Watch('handleBounds')
    addZoom (val: number[], old: number[]) {
      // This condition is needed as we want the bounds to be fit on the right
      // data provided by this.handleBounds
      if (this[this.activeTab] && this[this.activeTab].length) {
        this.$refs.destinationMap?.mapObject.fitBounds(this.handleBounds);
      }
    }

    /*
      This method will be triggered when tracks and spots are provided by
      parent. This method will display all tracks geoJsons, and spots markers.
      We will also fit bounds if needed, as the behavior is this one :
      - By default we fit on the bounds of the Destination.
      - If the destination contains routes or spots, then we want to fit on them
    */
    @Watch('tracks')
    @Watch('spots')
    fitOnGeoJsons () {
      const leafletInstance: any = this.$L;

      if (this.spots?.length) {
        this.spotMarkers = [];
        /* eslint-disable-next-line */
        this.spots.map((n: number) => {
          // We add markers on map for every spots provided by this.spots
          const marker = leafletInstance.marker(n);
          this.spotMarkers.push(marker);
        });
      }
      if (this.tracks?.length) {
        this.arrayOfGeoJsons = [];

        /* eslint-disable-next-line */
        this.tracks.map((t: {difficulty: string, track: any}) => {
          // We create a GeoJson object for each track provided by this.tracks
          const geojson = leafletInstance.geoJson(t.track);
          this.arrayOfGeoJsons.push(geojson);
        });
      }

      // We create a LeafletGroup of markers so we will be able to select them
      // in an easier way.
      this.spotMarkers = leafletInstance.featureGroup(this.spotMarkers);

      // If one of the two last arrays are provided, then we will fit bounds
      // on all the bounds of geoJsons and spots arrays.
      if (this.arrayOfGeoJsons.length || this.spotMarkers.length) {
        this.$refs.destinationMap.mapObject.fitBounds([
          this.arrayOfGeoJsons.map((g: any) => g.getBounds()),
          this.spotMarkers.getBounds(),
        ],
        );
      }
    }

    /*
      This computed will return bounds to be handled by map.
      This is an array of the bounds based on activeTab elements.
      If no children in element, we returns bounds of the destination. If yes,
      We will map every coordinates of children so the bounds will be fit on this
      array
    */
    get handleBounds () {
      switch (this.activeTab) {
        case 'routes': {
          if (this.routes.length > 0) {
            return this.routes?.map((r: any) => [r.lat, r.lng]);
          } else {
            return [this.destinationBounds, this.destinationBounds];
          }
        }
        case 'providers': {
          if (this.providers.length > 0) {
            return this.providers?.map((r: any) => [r.lat, r.lng]);
          } else {
            return [this.destinationBounds, this.destinationBounds];
          }
        }
        case 'events': {
          if (this.events.length > 0) {
            return this.events?.map((e: any) => [e.lat, e.lng]);
          } else {
            return [this.destinationBounds, this.destinationBounds];
          }
        }
        default: return this.$refs.destinationMap ? this.$refs.destinationMap.mapObject.getBounds() : [this.destinationBounds, this.destinationBounds];
      }
    }

    /* If a customHeight is provided by parent, we update the map height */
    created () {
      if (this.customHeight) {
        this.defaultHeight = this.customHeight;
      }

      if (this.destinationCountryCode === "FR") {
        this.currentTile = this.tileProviders[3];
        this.picked = this.currentTile.name;
      }
    }

    mounted () {
      // This method is triggered to handle map behavior on user scroll based on
      // its window innerWidth
      this.handleWheel();

      // Settings on button (need a ledge setTimeout to let map component load)
      this.$nextTick(() => {
        // Calls the method that will update style of zoom buttons
        this.stylizeZoomControl();

        // If this.customZoom is provided, we update map view with it
        if (this.customZoom) this.$refs.destinationMap.mapObject.setZoom(this.customZoom);

        // We also trigger this method in SSR mode to ensure provided tracks and
        // spots will be displayed on map when initiating component
        this.fitOnGeoJsons();
      });

      // Listening to resize event to handle map behavior
      window.addEventListener('resize', this.handleWheel, false);
    }

    destroyed () {
      // Remove resize event listener when destroying component
      window.removeEventListener('resize', this.handleWheel);
    }

    /*
      When user hovers an icon on map, se use leaflet method to update icon's style
    */
    addHoveredIcon (val: any) {
      val.sourceTarget.setIcon(this.focusedIcon);
    }

    /*
      Same logic than this.addHoveredIcon but removes the activeIcon style.
      If marker was a route/spot marker, we ensure the style is the right one when
      reset
    */
    removeHoveredIcon (val: any, type: string) {
      if (!this.focusedMarker) val.sourceTarget.setIcon(this.routesIcon);
    }

    /*
      This method is triggered when user clicks a marker, WHEN POPUP OPENS.
      We have to use @popupopen in template as v-marker-cluster gives bugs
      if we directly use @click events (bluring the popup directly when user
      clicks a marker spiderfied in a cluster).
      This method has this utility :
      - Populate the datas of the associated opened popup
      - Display the track of the route if the marker is a route
    */
    async addFocusedIcon (val: any) {
      const popupClass: string = val.popup._content.className;
      this.focusedMarker = val.popup;

      // Provider marker is the only icon that doesn't change if user clicks it
      if (!popupClass.includes('providerPopup')) {
        val.popup._source.setIcon(this.focusedIcon);
      }

      // We wait until the datas of the popup are fulfilled
      await this.handlePopupCard(val.popup.options);

      // We will display associated track of the route if marker is a route
      if (this.activeTab === 'routes') await this.spiderfyRouteMarkers({ id: val.popup.options.customId }, true);
    }

    /*
      This method works this way : it will populate the popup content based on
      selected marker by user when he clicks it.
      - If the content of the marker hasn't been fetched and isn't known in the
      store, we will fetch it and append it to the store array.
      - If the content of the marker has been fetched one time, we won't fetch it
      again and will use the value kept in store
    */
    async handlePopupCard (options: any) {
      // If the element exists in store, we will use it and avoid redundant API call
      const existsInList: Function = (list: any) => {
        return list?.items.some((item: Types.Route | Types.Provider | Types.Event) => item.id === options.customId);
      };

      // Switch to handle right action to do based on marker type
      // The switch will return an object that will be used in the template to
      // render the card in popup.
      switch (options.explorerType) {
        case 'ROUTE': {
          const existsInRouteList: boolean = existsInList(this.destinationRoutes);
          this.routeItem = {};
          /* eslint no-return-assign: 0 */
          if (existsInRouteList) return this.routeItem = this.destinationRoutes.items.find((item: Types.Route) => item.id === options.customId);
          else {
            await this.$store.dispatch('explorer/getRoute', { id: options.customId, lang: this.locale, appendToDestinationRoutesList: true });
            return this.routeItem = this.destinationRoutes.items.find((item: Types.Route) => item.id === options.customId) || {};
          }
        };

        case 'EVENT': {
          const existsInEventList: boolean = existsInList(this.destinationEvents);
          this.eventItem = {};
          /* eslint no-return-assign: 0 */
          if (existsInEventList) return this.eventItem = this.destinationEvents.items.find((item: Types.Event) => item.id === options.customId);
          else {
            await this.$store.dispatch('explorer/getEvent', { id: options.customId, lang: this.locale, appendToDestinationEventsList: true });
            return this.eventItem = this.destinationEvents.items.find((item: Types.Event) => item.id === options.customId) || {};
          }
        };

        case 'PROVIDER': {
          const existsInProviderList: boolean = existsInList(this.destinationProviders);
          this.providerItem = {};
          /* eslint no-return-assign: 0 */
          if (existsInProviderList) return this.providerItem = this.destinationProviders.items.find((item: Types.Provider) => item.id === options.customId);
          else {
            await this.$store.dispatch('explorer/getProvider', { id: options.customId, lang: this.locale, appendToRoutesList: true });
            return this.providerItem = this.destinationProviders.items.find((item: Types.Provider) => item.id === options.customId) || {};
          }
        };
      }
    }

    /*
      Following the same logic than this.addFocusedIcon, this method will reset
      the activeMarker icon to its default one. It also resets every datas
      associated and handled by this.addFocusedIcon.
    */
    async removeFocusedIcon (val: any) {
      let icon: any = this.routesIcon;
      // Using custom object datas declared in template to get marker type easily
      const popupClass: string = val.popup.options.explorerType;
      if (popupClass !== 'PROVIDER') {
        if (popupClass === 'ROUTE') icon = this.routesIcon;
        if (popupClass === 'EVENT') icon = this.eventsIcon;
        val.popup._source.setIcon(icon);
        this.focusedMarker = null;
      }
      // if (!popupClass.includes('providerPopup')) {
      //   val.popup._source.setIcon(icon);
      //   this.focusedMarker = null;
      // }
      this.routeItem = {};
      this.eventItem = {};
      this.providerItem = {};

      // Remove spiderfied markers to ensure no weird behaviors on map
      await this.spiderfyRouteMarkers(null, false);
    }

    /*
      This method will use leaflet methods to draw a polyline of the associated
      track of route.
    */
    async drawHoveredRoute () {
      const leafletInstance: any = window.L;

      // We will display hovered or clicked marker, based on available data.
      const idToUse: number = this.hoveredMarkerId ? this.hoveredMarkerId : this.hoveredRoute.id;

      if (!this.hoveredRoutes.some((r: Types.Route) => r.id === idToUse)) {
        await this.$store.dispatch('explorer/getHoveredRoute', { id: idToUse, lang: this.locale });
      }

      const route: any = this.hoveredRoutes.find((r: Types.Route) => r.id === idToUse);

      const array: any = [];
      const track: any = JSON.parse(route.track);
      const object: any = track.features[0].geometry?.coordinates;
      for (let i = 0; i < object.length; i++) {
        array.push([
          object[i][1],
          object[i][0],
        ]);
      }

      const polylineOnMap: any = leafletInstance.polyline(array, { color: this.routeColor(route.difficulty) });
      polylineOnMap.addTo(this.$refs.destinationMap.mapObject);
    }

    /* Switch that returns route color based on route difficulty */
    routeColor (val: number) {
      switch (val) {
        case 0: return '#9FA4AE';
        case 1: return '#3FA535';
        case 2: return '#009FE3';
        case 3: return '#CD171A';
        case 4: return '#000';
        default: return '#9FA4AE';
      }
    }

    /*
      This method will spiderfy clusters, which is useful when user hovers
      a card on explorer pages
    */
    async spiderfyCluster (val: any, ref: any) {
      const valId: number = val?.id;
      if (val) {
        // GetLayers is a leaflet method to get every layers on the map. We will
        // get markers layers after to get markers, and filter it to get the
        // active marker based on its popup id. Popup datas are very useful as
        // they contain a lot of datas related to their parent marker, and are
        // easier to handle.
        const markers: any = ref?.mapObject.getLayers();
        const markerFocused: any = await markers?.find((m: any) => Number(m._popup._content.id) === valId);

        const L: any = this.$L;

        // This variable will return a string based on cluster type.
        // If it's a div, it means that marker is contain inside a cluster.
        // And in this case, we will want to spiderfy it.
        const typeOfVisibleMarker: string = await L.markerClusterGroup(ref.mapObject).getVisibleParent(markerFocused)?._icon.tagName;

        if (markerFocused?.__parent._group._spiderfied === null) {
          if (markerFocused && typeOfVisibleMarker === 'DIV') {
            markerFocused?.__parent.spiderfy();
          }
        }
      }
    }

    /*
      As each provider contains a different icon, we create the icon based on
      provided argument.
    */
    createProviderIcon (source: string) {
      return this.$L.icon({
        iconUrl: source,
        iconSize: [50, 50],
        iconAnchor: [16, 37],
        className: 'resetMarkerClass',
      });
    }

    /* Provider icon is triggered in template. So we create the icon here */
    adaptedProviderIcon (provider: string) {
      switch (provider) {
        case 'FOOD': return this.createProviderIcon('/icons/PinProvidersEat.svg');
        case 'TODOTOSEE': return this.createProviderIcon('/icons/PinProvidersTodotosee.svg');
        case 'HOSTING': return this.createProviderIcon('/icons/PinProvidersHosting.svg');
        case 'SHOP': return this.createProviderIcon('/icons/PinProvidersShop.svg');
        case 'SERVICE': return this.createProviderIcon('/icons/PinProvidersService.svg');
      }
      return this.providersIcon;
    }

    /* Resets store values */
    destroyMap () {
      // this.$refs.destinationMap.mapObject.remove();
      this.$store.commit('explorer/SET_LOCALISATION_MAP_DISPLAY', false);
    }

    /*
      Toggle maps settings
    */
    toggleMapSettings () {
      this.isSettingsOpened = !this.isSettingsOpened;
    }

    /*
      Change layer of the current map
    */
    changeTile (index: number) {
      this.currentTile = this.tileProviders[index];
    }

    /* This method applies custom styles to zoom buttons of map. */
    stylizeZoomControl () {
      const plus: any = document.getElementsByClassName("leaflet-control-zoom-in")[0];
      const minus: any = document.getElementsByClassName("leaflet-control-zoom-out")[0];

      // content
      if (plus || minus) {
        plus.innerHTML = "";
        minus.innerHTML = "";
      }

      if (this.hideControls) {
        this.$refs.destinationMap.mapObject.dragging.disable();

        document.querySelectorAll('.leaflet-control-container').forEach((item: any) => {
          item.style.display = 'none';
        });
      } else if (this.customHeight) {
        document.querySelectorAll('.leaflet-top.leaflet-right').forEach((item: any) => {
          item.style.marginTop = '6rem';
          item.style.marginRight = '1.5rem';
        });

        document.querySelectorAll('.leaflet-top.leaflet-left').forEach((item: any) => {
          item.style.marginTop = '6rem';
          item.style.marginLeft = '1.5rem';
        });
      } else {
        document.querySelectorAll('.vue2leaflet-map').forEach((item: any) => {
          item.style.borderRadius = '0.5rem';
        });
      }
    }

    /*
      This method is called in mounted and in resize event listener.
      In mobile devices, we don't want the user to be able to scroll like a
      scrollWheelZoom type
    */
    handleWheel () {
      if (window.innerWidth < 321) {
        this.isXsDevice = true;
      } else {
        this.isXsDevice = false;
      }

      if (window.innerWidth < 768) {
        if (this.$refs.destinationMap?.mapObject.scrollWheelZoom.enabled()) {
          this.$refs.destinationMap?.mapObject.scrollWheelZoom.disable();
        }
      } else {
        this.$refs.destinationMap?.mapObject.scrollWheelZoom.enable();
      }
    }
}
